import STORE from '../../../../../../store';
import isDefined from '../../../../../../isDefined';
import isPerformanceBoard from '../../../../../../isPerformanceBoard';
import SectionTypeCheckers from '../../../../../../components/PerformanceBoards/PerformanceBoardSlideOut/sectionTypeCheckers';
import { useCallback, useContext } from 'react';
import BoardsContext from '../../../../../../contexts/BoardsContext';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import isGeneralBoard from '../../../../../../isBoardWithSlideOut';
import { FindAndReplace } from '../../types';

const useFindAndReplaceBoards = () => {
  const { boards } = useContext(BoardsContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const replaceBoards = useCallback(
    async (metricReceipt: FindAndReplace.MetricReceipt) => {
      const affectedBoardIds = metricReceipt?.affectedContentIds.boards;

      if (!affectedBoardIds?.length) {
        return;
      }

      const boardPromises = affectedBoardIds
        .map((boardId) => boards.find((b) => b.id === boardId))
        .filter(isDefined)
        .map((board) => {
          const { findMetricId, replaceMetricId } = metricReceipt;
          if (isPerformanceBoard(board)) {
            const newSlideout: PerformanceBoardTypes.SlideOut.SlideOutSection[] =
              board.slideout.map((bs) => {
                if (SectionTypeCheckers.isMetricSection(bs)) {
                  return {
                    ...bs,
                    metricIds: bs.metricIds.map((metricId) =>
                      metricId === findMetricId ? replaceMetricId : metricId,
                    ),
                  };
                }
                return bs;
              });

            const newPerformanceBoard: PerformanceBoardTypes.Board = {
              ...board,
              slideout: newSlideout,
            };
            return STORE.contentDistributions
              .getPerformanceBoardsRef({
                accountId: selectedAccountId,
              })
              .doc(newPerformanceBoard.id)
              .set(newPerformanceBoard);
          } else if (isGeneralBoard(board)) {
            let newBoard = structuredClone(board);
            if (!newBoard.metricIds?.length) {
              return Promise.resolve();
            }
            newBoard = {
              ...newBoard,
              metricIds: newBoard.metricIds.map((metricId) =>
                metricId === findMetricId ? replaceMetricId : metricId,
              ),
            };

            return STORE.getBoardsRef({
              accountId: selectedAccountId,
            })
              .doc(newBoard.id)
              .set(newBoard);
          }

          return Promise.resolve();
        });
      await Promise.all(boardPromises);
    },
    [boards, selectedAccountId],
  );

  return replaceBoards;
};

export default useFindAndReplaceBoards;
